import { Pagination as AntdPagination, type PaginationProps } from 'antd'

export const Pagination = (props: PaginationProps) => (
  <AntdPagination {...props} />
)

export default Pagination
